var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 1080,
    viewBox: "0 0 180 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-sidebar-bg {\n        fill: #022859;\n      }\n\n      .cls-2 {\n        fill: #103462;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(-10305 6552)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1616",
    "data-name": "Rectangle 1616",
    className: "cls-1-sidebar-bg",
    width: 180,
    height: 1080,
    transform: "translate(10305 -6552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    className: "cls-2",
    d: "M8752.943-5905.71l.082,335.719,179.912-107.494.006-334.114Z",
    transform: "translate(1552.057)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBg);
export default __webpack_public_path__ + "static/media/sidebar-bg.2920f976baa5a9dd1acc26452955263e.svg";
export { ForwardRef as ReactComponent };